export const sitecoreLearningQuickAction = {
  type: 'ui',
  name: 'Sitecore Learning',
  displayName: { name: 'Get world-class training and Sitecore certification' },
  icon: {
    type: 'mdi',
    src: 'mdiSchoolOutline',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://learning.sitecore.com/learn?utm_source=cloud-portal&utm_medium=help-section',
  },
};
